export default {
  global: {
    brandName: 'Wayke',
    brandWebsiteUrl: 'wayke.se',
    currencyUnit: 'kr',
    modalTitle: 'Värdera din bil i samarbete med {{brandName}}',
  },
  other: {
    loading: 'Laddar...',
    closeModal: 'Stäng modalen',
  },
  glossary: {
    change: 'Ändra',
    next: 'Nästa',
    modelYear: 'Modellår',
    manufactureYear: 'Tillverkningsår',
    gearbox: 'Växellåda',
    color: 'Färg',
    fuelType: 'Bränslegrupp',
    chassis: 'Kaross',
    segment: 'Segment',
    drivingWheel: 'Drivhjul',
    mileage: 'Miltal',
    mileageUnit_one: 'Mil',
    mileageUnit_other: 'Mil',
    condition: 'Skick',
  },
  error: {
    unspecific: 'Ett fel har inträffat. Försök igen.',
    valuation:
      'Tyvärr fick vi ingen träff på registreringsnummret du angav. Vänligen kontrollera att registreringsnummret stämmer.',
    vehicle:
      'Ajdå, vi verkar inte kunna hämta in någon data på den här bilen och kan inte ge dig någon värdering, det kan exempelvis bero på att bilen är importerad. Dubbelkolla också gärna att du skrivit in rätt registreringsnummer.',
  },
  footer: {
    poweredByBrand: 'Powered by {{link}}',
    poweredByBrandLinkTitle: 'Gå till {{website}}',
    poweredByBrandLinkUrl: 'https://www.wayke.se',
  },
  input: {
    registrationNumber: {
      label: 'Registreringsnummer',
      placeholder: 'Ange registreringsnummer',
      error: 'Ett giltig registreringsnummer i formatet ABC123 eller ABC12A måste anges',
    },
    mileage: {
      label: 'Miltal',
      placeholder: 'Ange bilens miltal',
      error: 'Ett giltigt miltal måste anges',
    },
    firstName: {
      label: 'Förnamn',
      placeholder: 'Ange förnamn',
      error: 'Du måste ange ditt förnamn',
    },
    lastName: {
      label: 'Efternamn',
      placeholder: 'Ange efternamn',
      error: 'Du måste ange ditt efternamn',
    },
    email: {
      label: 'E-postadress',
      placeholder: 'Ange e-postadress',
      error: 'Du måste ange din e-postadress',
    },
    phone: {
      label: 'Telefonnummer (valfritt)',
      placeholder: 'Ange telefonnummer',
      error: 'Du måste ange ditt telefonnummer',
    },
    branch: {
      label: 'Anläggning',
      placeholder: 'Välj anläggning',
      help: 'Vi har flera anläggningar i Sverige. Välj den anläggning som du vill komma i kontakt med.',
    },
    description: {
      label: 'Bra att känna till om min bil (valfritt)',
      placeholder:
        'Är det något mer om din bil som du vill berätta för oss? Något som kan påverka värdet så som servicehistorik, extrautrustning, vinterdäck?',
      error: 'Du måste lägga till en beskrivning',
    },
  },
  init: {
    title: 'Gratis värdering av din bil',
    expandedTitle: 'Värdera bilen gratis utan att binda dig till något',
    startButtonText: 'Starta värdering',
    expandButtonText: 'Expandera {{brandName}}s värderingsmodul',
    minifyButtonText: 'Förminska {{brandName}}s värderingsmodul',
    association: {
      body: 'Värdering i samarbete med {{link}}',
      linkTitle: 'Gå till {{website}}',
      linkUrl: 'https://www.wayke.se',
    },
  },
  summary: {
    thankYouMessage: 'Tack {{name}} för din intresseanmälan!',
    whatHappensNow: {
      heading: 'Vad händer nu?',
      body: [
        'Vi går igenom uppgifterna om din bil och kommer kontakta dig, vanligtvis inom 24 timmar. Därefter går vi tillsammans igenom alla detaljer och väljer du att gå vidare med försäljningen så hjälper vi dig med allt pappersarbete.',
        'Är du intresserad av att köpa en ny bil så kan vi hjälpa dig med det också.',
      ],
    },
    closeButtonText: 'Stäng',
  },
  confirmClose: {
    heading: 'Avsluta värderingen',
    body: 'Är du säker på att du vill avsluta värderingen?',
    buttonContinueText: 'Fortsätt med min värdering',
    buttonCancelText: 'Avbryt min värdering',
  },
  vehicleDetails: {
    label: 'Bulippgifter',
  },
  mileageAndCondition: {
    label: 'Bilens miltal och skick',
    heading: 'Uppge bilens miltal och skick',
    conditionRadioGroup: {
      label: 'Bilens skick',
      error: 'Måste välja bilens skick',
      help: 'Välj det alternativ som passar bilens skick bäst. Vill du sälja bilen kommer du i nästa steg även få skriva in själv ifall det är något som du tycker att vi behöver veta om din bil.',
    },
    seeEstimatedPurchasePrice: 'Se uppskattat inköpspris',
    condition: {
      veryGood: {
        label: 'Mycket bra skick',
        requirements: [
          'Inga repor eller skador',
          'Servad vid varje tillfälle med stämplar i serviceboken',
          'Däck med väldigt bra mönsterdjup (5-8 mm)',
        ],
      },
      good: {
        label: 'Bra skick',
        requirements: [
          'Några mindre repor och/eller skador',
          'Servad vid varje tillfälle med stämplar i serviceboken',
          'Däck som inte behöver bytas (mönsterdjup om 3-5 mm)',
        ],
      },
      ok: {
        label: 'Helt okej skick',
        requirements: [
          'Finns en del repor och skador',
          'Inte servad vid varje tillfälle',
          'Däck som behöver bytas (mönsterdjup under 3 mm)',
        ],
      },
    },
  },
  valuation: {
    label: 'Värdering',
    estimatedPurchasePrice: {
      heading: 'Uppskattat inköpspris',
      body: 'Ett spann mellan {{low}} and {{high}}.',
    },
    calculation: {
      heading: 'Hur har vi räknat ut det här?',
      body: [
        'Inköpspriset är baserat på liknande bilar på marknaden som är till salu just nu eller nyligen har legat ute till försäljning.',
        'Vi tar med en massa parametrar om just din bil för att ge ett så pricksäkert pris som möjligt, där vår tjänst hela tiden utvecklas och förbättras.',
        'Inköpspriset du får här är en indikation på bilens värde, men det slutgiltiga priset kan gå både upp och ned beroende på bilens skick och andra faktorer vi inte kunnat ta hänsyn till i denna värdering. För att kunna ge ett slutgiltigt inköpspris behöver vi se din bil och dess servicehistorik.',
        'Finns det för lite underlag på marknaden om just din bil kan det vara svårt att ge ett inköpspris. Ta då gärna kontakt med oss så kikar vi närmare på din bil i bilhallen istället.',
      ],
    },
    factors: {
      label: 'Faktorer som kan påverka försäljningspriset',
      positive: {
        heading: 'Faktorer som kan påverka försäljningspriset positivt kan vara:',
        usps: [
          'Om din bil har någon värdehöjande utrustning som vi inte kan se än så länge, exempelvis eftermonterad dragkrok eller nya fälgar.',
          'Om din bil är i väldigt bra skick och du har tagit extra väl hand om den.',
          'Om det just nu är stor efterfrågan på din modell.',
        ],
      },
      negative: {
        heading: 'Faktorer som kan påverka försäljningspriset negativt kan vara:',
        usps: [
          'Om det finns skador eller skavanker som gör att vi behöver göra reparationer innan vidareförsäljning.',
          'Om det är något i din bils historik som inte framkommer förrän vi kollat på bilen, exempelvis om det saknas servicestämplar.',
          'Om det finns många liknande bilar till salu just nu.',
        ],
      },
    },
  },
  about: {
    label: 'Information om hur värderingen fungerar',
    heading: 'Värdera bilen gratis',
    body: [
      'Med ditt registeringsnummer har vi hämtat ett flertal uppgifter om din bil. Ange bara bilens miltal och skick så får du kostnadsfritt ett uppskattat inköpspris av din bil.',
      'Vill du också sälja bilen kan du enkelt fylla i dina kontaktuppgifter så hör vi av oss till dig.',
    ],
    checklist: [
      'Värderingen är helt kostnadsfri',
      'Du väljer själv om du vill sälja bilen – och binder dig inte till något',
    ],
  },
  contact: {
    label: 'Intresseanmälan försäljning av bil',
    heading: 'Vill du sälja bilen?',
    body: 'Sälj din bil till oss! Fyll i intresseanmälan så kontaktar vi dig. Du binder dig inte till något genom att anmäla intresse.',
    detailsHeading: 'Kontaktuppgifter',
    carInformationHeading: 'Vill du lämna någon mer information om din bil?',
    nextStep: {
      heading: 'Vad är nästa steg?',
      body: 'Vi tar kontakt med dig för att tillsammans reda ut detaljerna kring din försäljning. Kom ihåg att du inte binder dig till något.',
    },
    requestError: 'Det gick inte att skicka iväg intresseanmälan. Försök igen.',
    disclaimer: {
      body: 'Ditt registreringsnummer och dina personuppgifter behandlas av vår värderingsleveranstör {{brandName}} och kommer delas med {{branch}}. {{link}}',
      link: {
        title: 'Läs mer om hur ditt registreringsnummer och dina personuppgifter behandlas',
        text: 'Läs mer',
        url: 'https://www.wayke.se/personuppgiftspolicy-wayke',
      },
    },
    sendFormButtonText: 'Skicka in intresseanmälan',
  },
};
